/** Functionality: 登入頁面 Author: Neil Date: 2019/12/04 */
<template>
  <div id="background">
    <div id="canvas__wrapper"></div>
  </div>
</template>
<script>
import "particles.js";
// !! not work in IE8, IE9
window.particlesJS.load("canvas__wrapper", "particlesjs-config.json");
export default {
}; // End of export
</script>
<style lang="scss" scoped>
#background {
  background: linear-gradient(to left top, rgb(41, 46, 49), rgb(5, 15, 13));
  position: absolute;
  min-width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  & > :not(#canvas__wrapper) {
    z-index: 80;
  }
}

#canvas__wrapper {
  position: fixed;
  width: 100vw;
  height: 100%;
  max-height: 100vh;
  overflow: hidden;
}
</style>
